import React, { useCallback, useEffect, useRef, useState } from 'react';
import "./QrCode.css";
import scanner from "../../assets/icons/scanner.png";
import TopHeader from "../../components/TopHeader.tsx";
import QrPdfComponent from './QrPdfComponent.tsx';
import html2pdf from "html2pdf.js";
import axios from 'axios';

const QrCode = ({ tableId, restaurantId }) => {
    const componentRef = useRef();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<any>({});

    const handleDownloadPdf = () => {
        const element = componentRef.current;
        const opt = {
            margin: 1,
            filename: "QrCode.pdf", // Name of the PDF file
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true }, // Improves the quality of the image
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        };

        // Use html2pdf to generate and download the PDF
        html2pdf().from(element).set(opt).save();
    };

    const getRestaurantInfo = useCallback(async (table: string = "f8a62713-e931-4fac-aab3-f8740f902f9c", restaurant: string = "19bfba9f-c1c2-48eb-b88d-5f7048911cfe") => {
        if (table && restaurant) {
            try {
                setError("");
                setLoading(true);

                const response = await axios.get(`${process.env.REACT_APP_SECRET}/api/RestaurantTable/GetSelectedTableByTableIdAndRestaurantId?tableId=${table}&restaurantId=${restaurant}`);

                setData(response.data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setError(error.response.data);
            }
        }
    }, [tableId, restaurantId]);

    useEffect(() => {
        getRestaurantInfo(tableId, restaurantId);
    }, [getRestaurantInfo]);

    return (
        <div>
            <TopHeader></TopHeader>
            <QrPdfComponent
                scanner={scanner}
                data={data}
                componentRef={componentRef}
            />
            <div className="download-btns">
                <button className="download-btn" onClick={handleDownloadPdf}>Download html 2 pdf</button>
            </div>
        </div>
    );
};

export default QrCode;